"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.REQUEST = exports.SAGA = void 0;
var SAGA = 'apiFlow/emailSettings/changeAllStatus/SAGA';
exports.SAGA = SAGA;
var REQUEST = 'apiFlow/emailSettings/changeAllStatus/REQUEST';
exports.REQUEST = REQUEST;
var SUCCESS = 'apiFlow/emailSettings/changeAllStatus/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/emailSettings/changeAllStatus/FAILURE';
exports.FAILURE = FAILURE;